import * as React from "react";
import { makeStyles, Typography } from "@material-ui/core";

import { CardButton } from "../card";

import { colors } from "../../styles/color.styles";

export interface ProCalloutCardButtonProps {
  onViewPlans: () => void;
}

const useStyles = makeStyles({
  container: {},
  bold: {
    fontWeight: "bold",
  },
  button: {
    color: colors.blueSky.darker,
    border: "0.930502px solid #23A7BC",
    paddingTop: 7,
  },
  card: {
    color: colors.blueSky.darker,
    fontSize: 14,
    marginTop: 10,
    border: "0.930502px solid #23A7BC",
    background:
      "linear-gradient(0deg, rgba(184, 242, 251, 0.25), rgba(184, 242, 251, 0.25)), #FFFFFF",
  },
});

export const ProCalloutCardButton = ({ onViewPlans }: ProCalloutCardButtonProps) => {
  const classes = useStyles();

  return (
    <CardButton
      buttonProps={{ children: "VIEW PLANS", className: classes.button, onClick: onViewPlans }}
      className={classes.card}
      variant="borderless" // Defining own border in classes.card
    >
      <Typography>
        Upgrade your free plan to allow Clockwise to keep breaks between long blocks of consecutive
        meetings.
      </Typography>
    </CardButton>
  );
};
